import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

import s from './retranslateButton.module.scss';

type RetranslateButtonProps = {
  translationTooltip: string;
  translateFunction: () => void;
};

export const RetranslateButton = ({
  translationTooltip,
  translateFunction,
}: RetranslateButtonProps): JSX.Element => {
  return (
    <div className={s.retranslateButton}>
      <Tooltip content={translationTooltip}>
        <IconButton
          variant="tertiary"
          icon="translate"
          onClick={translateFunction}
        />
      </Tooltip>
    </div>
  );
};
